import { Poker2Model } from "../../../model/Poker2Model";
import { PokerTextHelper } from "../../helper/PokerTextHelper";

import MovieClip = createjs.MovieClip;
import {Poker2LayoutManager} from "../../Poker2LayoutManager";

export class CardRankingHelp2 {
    private _target: MovieClip;

    constructor(target: MovieClip) {
        this._target = target;
        this._target.visible = false;
        this.initTextFields();
    }

    private initTextFields(): void {
        //			TextFieldHelper.changeTextFromatSizeByTextWidth( 10, _target.tf_fold, Poker2Model.languageData.getTextById( "table_actionPanel_help_fold" ),3);
        //			TextFieldHelper.changeTextFromatSizeByTextWidth( 10, _target.tf_check, Poker2Model.languageData.getTextById( "table_actionPanel_help_check" ),2);
        //			TextFieldHelper.changeTextFromatSizeByTextWidth( 10, _target.tf_call, Poker2Model.languageData.getTextById( "table_actionPanel_help_call" ),2);
        //			TextFieldHelper.changeTextFromatSizeByTextWidth( 10, _target.tf_raise, Poker2Model.languageData.getTextById( "table_actionPanel_help_raise" ),2);
        //			TextFieldHelper.changeTextFromatSizeByTextWidth( 10, _target.tf_allIn, Poker2Model.languageData.getTextById( "table_actionPanel_help_allin" ),2);

        this._target.tf_fold.text = Poker2Model.languageData.getTextById("table_actionPanel_help_fold");
        this._target.tf_check.text = Poker2Model.languageData.getTextById("table_actionPanel_help_check");
        this._target.tf_call.text = Poker2Model.languageData.getTextById("table_actionPanel_help_call");
        this._target.tf_raise.text = Poker2Model.languageData.getTextById("table_actionPanel_help_raise");
        this._target.tf_allIn.text = Poker2Model.languageData.getTextById("table_actionPanel_help_allin");

        PokerTextHelper.writeLabel("table_actionbox_allin", this._target.btn_allIn.txt_label, 9);
        PokerTextHelper.writeLabel("table_actionbox_raise", this._target.btn_raise.txt_label, 9);
        PokerTextHelper.writeLabel("table_actionbox_call", this._target.btn_call.txt_label, 9);
        PokerTextHelper.writeLabel("table_actionbox_check", this._target.btn_check.txt_label, 9);
        PokerTextHelper.writeLabel("table_actionbox_fold", this._target.btn_fold.txt_label, 9);

        this._target.btn_allIn.txt_label.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        this._target.btn_raise.txt_label.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        this._target.btn_call.txt_label.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        this._target.btn_check.txt_label.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        this._target.btn_fold.txt_label.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
    }

    public fadeIn(): void {
        this._target.visible = true;

        // btns sind nur zur ansicht, frame 2 sieht schöner aus
        this._target.btn_allIn.gotoAndStop(2);
        this._target.btn_raise.gotoAndStop(2);
        this._target.btn_call.gotoAndStop(2);
        this._target.btn_check.gotoAndStop(2);
        this._target.btn_fold.gotoAndStop(2);
    }

    public fadeOut(): void {
        this._target.visible = false;
    }
}
